import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../../components/common';
import DatePickerMui from '../../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../../components/ui';
import { convToTime } from '../../../../../../utils/helpers';
import { useQuery } from '../../../../../../hooks/UseQuery';

interface IProps {
  top20?: any;
}
const THead = ({ top20 }: IProps) => {
  const annual_month = useQuery('annual_date') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={top20 ? 26 : 24}
        rowSpan={3}
        labels={['Doc. No.- ', 'Rev. No.- ', 'Date:- ']}
        values={['F05 QAD 05', '00', '18.06.18']}
        heading={
          top20 ? 'Top 20 Parts Rejection Data' : 'Rejection Data- Month-wise'
        }
      />
      <tr style={{ background: '#9775fa', color: 'white' }}>
        <th
          colSpan={top20 ? 26 : 24}
          style={{ background: 'orange', color: 'black', fontWeight: 'bold' }}
          align="left"
        >
          Month : {annual_month}
        </th>
      </tr>
      <tr>
        {[
          'Sr No.',
          'PART NAME',
          'BLANK SHORT',
          'CRACK',
          'TRIM',
          'BENDING SHIFT',
          'DAMAGE',
          'DOUBLE STAMPING',
          'DIMPLE NG',
          'DIMPLE DIA.',
          'DENT',
          'HOLE DIA. NG',
          'PUNCH OUT',
          'HOLE SHIFT',
          'HEAVY SCRATCH',
          'HEAVY BURR',
          'WELDING FAULT',
          'operation miss',
          'DIMPLE MISS',
          'GAUGE NG',
          'RUSTY',
          'DEMAGE',
          'SLUG JAM',
          'Partwise Monthly Rej. Total',
        ].map((headingData) => (
          <th>{headingData}</th>
        ))}
        {top20 &&
          ['CUMM. REJECTION', 'CUMM. %'].map((headingData) => (
            <th>{headingData}</th>
          ))}
      </tr>
    </thead>
  );
};

export default THead;
